<head><meta name="viewport" content="width=device-width, initial-scale=1.0"></head>
<p>
  contact works!
</p>
